
import {
  computed,
  ComputedRef,
  defineComponent,
  onBeforeMount,
  ref,
  watch
} from "vue";
import Search from "../inputs/Search.vue";
import LineOnlineTraining from "../LineOnlineTraining.vue";
import LineFaceTraining from "../LineFaceTraining.vue";
import { dispatchError } from "../../../utils/error_handling";
import { Course } from "../../../../../domain/entities/entities";
import { wrapLoading } from "../../../utils/wrap_loading";
import { useStore } from "vuex";
import { getOrderFromURL } from "../../../utils/order_utils";
import { useRoute, useRouter } from "vue-router";
import PaginationDefault from "../shop/PaginationDefault.vue";
import { updateQuery } from "../../../utils/routing_utils";
import { search } from "../data-table/table-order-utils";
import ContentFallback from "../moldure/ContentFallback.vue";

export default defineComponent({
  name: "FavoriteTraining",
  methods: { search, updateQuery },
  components: {
    ContentFallback,
    PaginationDefault,
    LineFaceTraining,
    LineOnlineTraining,
    Search
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const selectedFilter = ref(route.query.type?.toString() || "");

    const numberOfPages = computed(
      () => store.getters["course_module/numberOfPagesFavorite"]
    );

    const favoritesTrainings: ComputedRef<Course[]> = computed(() => {
      return store.getters["course_module/favoritesTrainings"];
    });

    onBeforeMount(async () => {
      await wrapLoading(async () => {
        await listFavoriteTrainings();
      });
    });

    const listFavoriteTrainings = async (): Promise<void> => {
      try {
        const order = getOrderFromURL(route);

        await store.dispatch("course_module/listFavoriteTrainings", order);
      } catch (e) {
        await dispatchError(e);
      }
    };

    const goToTrainingView = async (courseID: number): Promise<void> => {
      await router.push({
        name: "course",
        params: {
          course_id: courseID
        }
      });
    };

    watch(
      () => route.query,
      async () => {
        await wrapLoading(async () => {
          await listFavoriteTrainings();
        });
      }
    );

    const sortTrainingTypes = async (): Promise<void> => {
      if (selectedFilter.value !== "") {
        await updateQuery(router, "type", selectedFilter.value);
      } else {
        await updateQuery(router, "type", "");
      }

      await updateQuery(router, "page", "1");
    };

    return {
      favoritesTrainings,
      numberOfPages,
      selectedFilter,
      goToTrainingView,
      sortTrainingTypes,
      search
    };
  }
});
